import Form, { Rule } from 'antd/es/form'
import { FC } from 'react'
import { requiredOneElementRules } from '../../../constants/forms/validation/rules'
import { Select } from 'antd'
import { useGetMaterialGroupsQuery } from '../../../store/api/material-groups-api'

interface MaterialGroupsProps {
    noStyle?: boolean
    rules?: Rule[]
}

const MaterialGroups: FC<MaterialGroupsProps> = ({ noStyle, rules = requiredOneElementRules }) => {
    const { data } = useGetMaterialGroupsQuery()

    return (
        <Form.Item name={'materialGroups'} label={'Виды матерала'} rules={rules} noStyle={noStyle}>
            <Select
                style={{ width: '100%' }}
                options={data?.data.map(item => ({ value: item.documentId, label: item.name }))}
                mode={'multiple'}
            />
        </Form.Item>
    )
}

export default MaterialGroups
